<template>
  <div id="pay-ensure-modal">
    <el-dialog
      title="补充联系邮箱"
      v-model="showModal"
      custom-class="peer-email-dialog"
      :show-close="true"
      :close-on-click-modal="false"
      @close="cancelModal"
    >
      <el-form
        :model="peerInfo"
        :rules="rules"
        ref="peerInfo"
        label-width="90px"
      >
        <el-form-item label="邮箱" prop="peer_email">
          <el-input v-model="peerInfo.peer_email" placeholder="请输入邮箱" :maxlength="50"></el-input>
         <span class="tips">此邮箱用于接收面试通知书、电子签证等重要信息</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="cancelModal">取消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validates from '@/libs/validates';
import Http from '../../../libs/http';
// import utils from '../../libs/utils';

export default {
  name: 'peer-email-modal',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      showModal: this.value,
      peerInfo: {
        peer_email: '',
      },
      rules: {
        peer_email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { pattern: validates.inputRegexpCollection.emailReg, message: '请输入正确的邮箱', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    // 取消确认支付弹窗
    cancelModal() {
      this.$refs.peerInfo.resetFields();
      this.$emit('input', false);
    },

    // 点击确认
    confirm() {
      this.$refs.peerInfo.validate((valid) => {
        if (valid) {
          // 将同业邮箱同步到oss接口;
          Http.post('/peer_email_update', { email: this.peerInfo.peer_email }).then(() => {
            this.$message.info('邮箱填写成功');
          }).catch((e) => {
            if (e) console.log(e);
            this.$message.info('邮箱填写失败');
          });
          this.$emit('updatePeerEmail', this.peerInfo.peer_email);
          this.$emit('input', false);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      
    },
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
    },
  },
};
</script>

<style lang="less">
#pay-ensure-modal {
  .peer-email-dialog {
    width: 480px;
    border-radius: 5px;

    .tips{
      color: #999;
      font-size: 14px;
    }
    .el-dialog__body{
      padding: 20px 20px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/modals/supplement-peer-email-modal.vue